import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/CD.png";
import CDFAQ from "./CDFAQ";
import CDCurriculum from "./CDCurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import CDPricing from "./CDPricing";
import { Link } from "react-router-dom";
export default function CarDesign() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "Car Design",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxpGr46MBF4HmNpxOYLbt2mQRcjEVPS5PtI1iZdXAMgIxORthvV4iD0Ev1zPEAsXZoK/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "Car Design",
        });
      } else {
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "Car Design",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">Car Design</h1>
          <p className="program-detail-desc">
            Car design turns engineering into emotion. It blends aerodynamics, performance, ergonomics, and aesthetics to create vehicles that feel powerful, safe, and alive. From concept sketches to 3D models, every curve and angle shapes how a car moves, looks, and inspires.
          </p>
          <div className="program-detail-actions">
            <Link to="/register">
              <button className="register-btn">Register Now</button>
            </Link>
            <Link to="/contact-us">
              <button className="expert-btn">Talk To Expert</button>
            </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
            Car design isn’t just drawing—it’s understanding how humans connect with machines. At Acadme, you learn the full design journey: sketching concepts, understanding proportions, surfaces, interiors, aerodynamics, and digital modeling. You explore industry tools like Figma, Blender, SolidWorks, and automotive visualization techniques. Training is hands-on—you create 3D forms, refine details, and convert ideas into realistic models. During the internship, you collaborate on real automotive tasks, review feedback from mentors, and witness how design decisions influence safety, comfort, and performance. You learn how professionals work with engineers, clients, and production teams. If you want to create machines that move people in every sense—enroll and start your journey.
          </p>
        </motion.div>
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>

          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <CDCurriculum />
      <SkillPage />
      <Certificate />
      <CDPricing />
      <CDFAQ />
    </>
  );
}
